const COMMENTS = [
  {
    id: 1,
    name: '漫画迷小王',
    avatar: 'https://readdy.ai/api/search-image?query=A%20minimalist%20cute%20avatar%20illustration%20of%20a%20young%20person%20with%20warm%20smile%20simple%20flat%20style%20warm%20coral%20background%20clean%20design&width=80&height=80&seq=avatar-comment-01&orientation=squarish',
    text: '从4399漫画网转过来的，99漫画的下拉式阅读体验真的好太多了！韩漫日漫资源也全，收藏追更功能很贴心，已经安利给身边所有漫友了。',
    date: '3天前',
    likes: '2.3k',
  },
  {
    id: 2,
    name: '深夜追更人',
    avatar: 'https://readdy.ai/api/search-image?query=A%20minimalist%20cute%20avatar%20illustration%20of%20a%20person%20with%20glasses%20reading%20simple%20flat%20style%20warm%20amber%20background%20clean%20design&width=80&height=80&seq=avatar-comment-02&orientation=squarish',
    text: '国漫崛起期能找到这样一个免费全集的平台真的不容易，更新速度很快，画质也很清晰。希望99漫画越做越好，多引进一些热门韩漫！',
    date: '5天前',
    likes: '1.8k',
  },
  {
    id: 3,
    name: '漫画研究员',
    avatar: 'https://readdy.ai/api/search-image?query=A%20minimalist%20cute%20avatar%20illustration%20of%20a%20person%20with%20headphones%20simple%20flat%20style%20warm%20coral%20background%20clean%20design&width=80&height=80&seq=avatar-comment-03&orientation=squarish',
    text: '对比了几个同类型平台，99漫画的免费政策和下拉式阅读流程做得最好。日漫经典全集也很齐全，配合追更功能基本不用再去其他地方找漫画了。',
    date: '1周前',
    likes: '1.5k',
  },
];

export default function CommentsSection() {
  return (
    <section id="comments" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-3">读者评价</h2>
          <p className="text-sm text-foreground-600">
            来自真实读者的使用反馈，听听漫迷们怎么说
          </p>
        </div>

        <div className="space-y-4">
          {COMMENTS.map((comment) => (
            <div
              key={comment.id}
              className="bg-background-100 border border-background-200/60 rounded-xl p-5 md:p-6"
            >
              <div className="flex items-center gap-3 mb-3">
                <div className="w-9 h-9 rounded-full overflow-hidden bg-background-200 flex-shrink-0">
                  <img
                    src={comment.avatar}
                    alt={comment.name}
                    className="w-full h-full object-cover"
                    loading="lazy"
                  />
                </div>
                <div>
                  <h3 className="text-sm font-semibold text-foreground-900">{comment.name}</h3>
                  <span className="text-xs text-foreground-400">{comment.date}</span>
                </div>
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed mb-3">{comment.text}</p>
              <div className="flex items-center gap-1 text-xs text-foreground-400">
                <i className="ri-thumb-up-line"></i>
                <span>{comment.likes} 觉得有用</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}